import { render } from "./dismantleDeskModel.vue?vue&type=template&id=58a8cfac"
import script from "./dismantleDeskModel.vue?vue&type=script&lang=js"
export * from "./dismantleDeskModel.vue?vue&type=script&lang=js"

import "./dismantleDeskModel.vue?vue&type=style&index=0&id=58a8cfac&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__